import SyncCenter from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import { SyncCenterDataRelay } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterDataRelay';

/**
 *
 *
 * @export
 * @class SyncCenterLoader
 * 同步盘的中枢的加载器
 * 用于处理：
 * 启动场景延迟加载，避免抢占资源
 * 同步盘页面立即加载
 */
export class SyncCenterLoader {
  public whenCenterReady: Promise<SyncCenter>;
  private center!: SyncCenter;
  private centerDataRelay: SyncCenterDataRelay;

  private readonly userInfo: CoFile.UserInfo;
  private isLoaded = false;
  private timeoutHandler: NodeJS.Timeout | null = null;
  private manualLoadResolve!: (value: SyncCenter) => void;
  private manualLoadReject!: (reason?: any) => void;

  constructor(userInfo: CoFile.UserInfo) {
    this.userInfo = userInfo;
    this.centerDataRelay = new SyncCenterDataRelay();

    const whenDelayLoad = new Promise<SyncCenter>((resolve, reject) => {
      this.timeoutHandler = setTimeout(() => {
        resolve(this.load(userInfo));
        this.timeoutHandler = null;
      }, 15000);
    });

    const whenManualLoad = new Promise<SyncCenter>((resolve, reject) => {
      this.manualLoadResolve = resolve;
      this.manualLoadReject = reject;
    });

    this.whenCenterReady = Promise.race([whenDelayLoad, whenManualLoad]);
  }

  private load(userInfo: CoFile.UserInfo): SyncCenter {
    this.isLoaded = true;
    this.centerDataRelay.reset();
    this.center = new SyncCenter(userInfo, this.centerDataRelay);
    return this.center;
  }

  public immediatelyLoad() {
    if (!this.isLoaded) {
      const center = this.load(this.userInfo);
      this.manualLoadResolve(center);

      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
    }
  }

  public getCenter(): SyncCenter {
    if (!this.isLoaded) {
      this.immediatelyLoad();
    }
    return this.center;
  }

  public getCenterDataRelay(): SyncCenterDataRelay {
    return this.centerDataRelay;
  }

  public async unInit() {
    if (this.isLoaded) {
      const center = await this.whenCenterReady;
      await center.unInit();
    } else {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.timeoutHandler = null;
      }
    }
  }
}
